export const EN_TRANSLATE = {
    "HELLO": "Hello",
    "back": "Back",
    "ok": "Ok",
    "cancel" : "Cancel",
    "startBtn": "Start",

    "detox" : "Detox",
    "detoxPlan" : "Menus and Recipes",
    "settings" : "Settings",
    "shoppingList" : "Shopping list",
    "termsOfUse" : "Terms of use",
    "guides" : "Guides",
    "aboutUs" : "About us",
    "slogan" : "21 days of healthy body cleansing",

    "dailyMenu": "Daily menu",
    "day": "Day",
    "finish": "What now",
    "ingredients": "Ingredients",
    "instructions": "Instructions",
    "intro": "Intro",
    "markThisDay": "Mark this day as done",
    "serving": "Serving",
    "servings": "Servings",
    "meals": [
    {
        "name": "Breakfast"
    },
    {
        "name": "Mid-morning"
    },
    {
        "name": "Lunch"
    },
    {
        "name": "After noon"
    },
    {
        "name": "Dinner"
    }
    ],

    "more": "more",
    "language": "Language",

    "he": "עברית",
    "en": "English",
    "ge": "Deutsch",
    "ru": "русский",
    "fr": "français",
    "sp": "español",
    "po": "português",

    "unit": "Unit",
    "selectDetoxPlan": "Select your detox plan",
    "detoxPlans": "Detox plans",
    "restart": "Restart",
    "start": "Start",
    "days" : "days",
    "standard": "standard",
    "vegan" : "vegan",
    "vegetarian" : "vegetarian",
    "pescetarian" : "pescetarian",
    "wellDone":"Well done!",
    "whatsNow": "Whats now",
    "youDidIt":"Well done, you did it",
    "weProud":"We are proud of you,",
    "presentYourself":"You gave yourself an amazing gift",



    
    "messages": {
        "resetApp": {
            "title" : "Reset the App",
            "content" : "This action will reset the shoping list and the days you marked as done.\nPress OK if you want to reset the app."
        }
    },
}
